<template>
	<div :style="viewStyles" class="">

		<customer-list v-model="selectedCustomerId" :customers="customers"/>

		<bottom-navigation @new-height="setBottomPadding">
			<template v-slot:left>
				<button class="btn btn-light btn-block" @click="$router.back()">{{ $t('Abbrechen') }}</button>
			</template>
			<template v-slot:right>
				<button class="btn btn-primary btn-block"
				        @click="continueWithCustomer"
				        :disabled="selectedCustomerId === null"
				>
					{{ $t('Weiter') }}
				</button>
			</template>
		</bottom-navigation>
	</div>

</template>

<script>
import BottomNavigation from "../../components/BottomNavigation";
import allViews from "../../mixins/allViews";
import DataInput from "../../components/DataInput";
import {mapActions, mapMutations, mapState} from "vuex";
import CustomerList from "../../components/CustomerList";

export default {
	name: "ChooseCustomer",
	components: {CustomerList, DataInput, BottomNavigation},
	mixins: [allViews],
	computed: {
		...mapState({
			customers: state => state.Api.Customers.all,
			scid: state => state.selectedCustomerId,
		}),
		selectedCustomerId: {
			get() {
				return this.scid;
			},
			set(id) {
				this.setSelectedCustomerId(id)
			},
		}
	},
	created() {
		this.refreshCustomers()
			.catch(this.apiErrorHandler)
	},
	methods: {
		...mapActions({
			refreshCustomers: "Api/Customers/all",
		}),
		...mapMutations({
			setSelectedCustomerId: "setSelectedCustomerId"
		}),
		continueWithCustomer() {
			this.$router.push('/from_customer/customer/scanner').catch(() => null)
		}
	}
}
</script>
